function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M118.536 1.46443C116.583 -0.488145 113.417 -0.488145 111.465 1.46443L1.46443 111.465C-0.488145 113.417 -0.488145 116.583 1.46443 118.536C3.41701 120.488 6.58295 120.488 8.53553 118.536L118.536 8.53553C120.488 6.58295 120.488 3.41725 118.536 1.46443Z",
  fill: "#3F95BC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.9999 80C88.9536 80 80 88.9536 80 99.9999C80 111.046 88.9534 120 99.9999 120C111.046 120 120 111.046 120 100C120 88.9538 111.046 80 99.9999 80ZM99.9999 110C94.4764 110 89.9998 105.524 89.9998 99.9999C89.9998 94.4762 94.4762 90.0001 99.9999 90.0001C105.524 90.0001 110 94.4764 110 100C110 105.524 105.523 110 99.9999 110Z",
  fill: "#3F95BC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.9999 40.0001C31.0462 40.0001 39.9998 31.0465 39.9998 20.0002C39.9998 8.95383 31.0465 0 19.9999 0C8.95336 0 0 8.95359 0 19.9999C0 31.0462 8.95359 40.0001 19.9999 40.0001ZM19.9999 10.0001C25.5234 10.0001 30 14.4764 30 20.0002C30 25.5239 25.5237 30 19.9999 30C14.4762 30 9.99984 25.5237 9.99984 19.9999C9.99984 14.4762 14.4764 10.0001 19.9999 10.0001Z",
  fill: "#3F95BC"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

function SvgRatiosProportionalRelationships(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatiosProportionalRelationships);
export default __webpack_public_path__ + "static/media/ratios-proportional-relationships.b52ae79a.svg";
export { ForwardRef as ReactComponent };